<template>
  <div class="login-page">
    <!-- Error snackbar -->
    <v-snackbar color="error" v-model="showError" top>
      {{ textError }}
      <v-btn text @click="showError = false">Fermer</v-btn>
    </v-snackbar>

    <v-container fill-height>
      <v-layout wrap text-center>
        <v-flex xs12 align-self-center>
          <v-img
            :src="require('../../assets/img/logo.svg')"
            height="321"
            contain
          ></v-img>
        </v-flex>
        <v-layout justify-center>
          <v-flex sm3>
            <h4 class="error--text" v-if="showError && error">{{ error }}</h4>
            <v-form class="mb-5">
              <v-text-field
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                type="email"
                label="Email"
                v-model="form.email"
                :counter="50"
                required
                dark
                autofocus=""
              ></v-text-field>
              <v-text-field
                v-validate="'required'"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                label="Mot de passe"
                v-model="form.password"
                type="password"
                :counter="50"
                required
                dark
                autofocus=""
              ></v-text-field>
              <v-flex mt-5>
                <v-btn
                  :loading="isLoading"
                  :disabled="isLoading"
                  color="#006064"
                  @click="onSubmit"
                  ripple
                  rounded
                  large
                  width="200"
                  dark
                  >Connexion</v-btn
                >
              </v-flex>
            </v-form>
            <router-link style="color: white !important; text-decoration: none" to="/forgot-password">Mot de passe oublié</router-link>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "LoginPage",
    data() {
      return {
        // Form data
        form: {
          email: "",
          password: ""
        },

        // Loading
        isLoading: false,

        // Errors
        showError: false,
        textError: null
      };
    },
    computed: {
      ...mapGetters({
        userRole: "user/userRole"
      })
    },
    methods: {
      ...mapActions({
        login: "user/login"
      }),

      // Clear errors
      clearError() {
        this.showError = false;
        this.error = null;
      },

      // Perform login
      async onSubmit() {
        try {
          // Validate form
          const isValid = await this.$validator.validate();
          if (!isValid) {
            return;
          }

          this.isLoading = true;

          // Perform Login
          await this.login(this.form);

          if (this.userRole == "SEWING") {
            this.$router.push({ name: "PlanningsPage" });
            return;
          }

          this.$router.push("/");
        } catch (error) {
          this.isLoading = false;
          this.showError = true;

          if (error.response.status === 401) {
            this.textError = "Mauvais identifiants";
            return;
          }

          this.textError = "Une erreur est survenue";
        }
      }
    }
  };
</script>

<style lang="scss">
  .login-page {
    height: 100%;
    background: rgb(136, 14, 79);
    background: linear-gradient(
      20deg,
      rgba(136, 14, 79, 1) 56%,
      rgba(71, 0, 77, 1) 100%
    );
  }
</style>

<style lang="scss">
  #app {
    .login-page {
      .container {
        .layout {
          .v-input {
            .v-input__control {
              .v-input__slot {
                .v-text-field__slot {
                  label {
                    &.v-label--active {
                      color: #ffffff !important;
                    }
                  }
                  input {
                    color: white !important;
                  }
                  input:-webkit-autofill,
                  input:-webkit-autofill:hover,
                  input:-webkit-autofill:focus,
                  input:-webkit-autofill {
                    -webkit-text-fill-color: white !important;
                    -webkit-box-shadow: 0 0 0px 1000px #880e4f inset;
                    box-shadow: 0 0 0px 1000px #880e4f inset;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
